import { Button, colors, OptionGroup, Paragraph, Typography } from '@microfrontends/react-components'
import { ResumeDesc, RightButtonWrapper } from './makeProfileSearchable.css'
import { EDevice, useStore } from '../../../../store'
import { ResumeType, SEARCHABLE_ON, vnwBasePath } from '../constants'
import React from 'react'
import { useProfileSettingStore } from '../../../../store/ProfileSetting'
import { TResumeInfo } from '@microfrontends/react-components/components/hooks/useMakeSearchable/types'

interface IProps {
    trans: (value: any) => string
    searchableResume: Partial<TResumeInfo> | null
}

function OnlineProfile({ trans, searchableResume }: IProps) {
    const { state } = useStore()
    const {
        state: settingState,
        state: { resumeId },
        setState: disPatchSettingState
    } = useProfileSettingStore()

    const { profileSettingInfo, profileLevel } = state
    const { resumeSetting } = profileSettingInfo
    const profile = resumeSetting.profileInfo
    const attachment = resumeSetting.attachInfo

    const onUpdateProfileBtnClick = () => {
        window.location.assign(trans('/my-profile'))
    }

    const haveProfile = profile?.allowSearchableDisplay === SEARCHABLE_ON

    let isSearchable = profile.isSearchable === 1
    const filteredSearchable = attachment.filter((item) => item.isSearchable === 1)
    if (filteredSearchable.length > 0) {
        isSearchable = true
    }

    let currentResumeId = resumeId
    if (searchableResume !== null && searchableResume.id && !isSearchable) {
        currentResumeId = searchableResume.id
    }


    return (
        <>
            <Typography name='label' size='medium' color={colors.grey[20]}>
                {trans('By VietnamWorks profile')}
            </Typography>
            <OptionGroup
                value={String(profile.id)}
                label={trans('VietnamWorks profile')}
                align='left'
                styles={{
                    wrapperStyle: {
                        marginBottom: 0
                    }
                }}
                name={ResumeType.Profile}
                onChange={(res) => disPatchSettingState({ ...settingState, resumeId: Number(res) })}
                disabled={!haveProfile}
                contentDisable={false}
                checked={profile.id === currentResumeId}
            >
                {haveProfile ? (
                    <ResumeDesc>
                        <Paragraph name='label' size='small' color={colors.grey[60]}>
                            {profileLevel.profileStrength ?? 0}% {trans('completed')}
                        </Paragraph>
                    </ResumeDesc>
                ) : (
                    <>
                        <Paragraph name={'body'} size={'medium'} color={colors.grey[20]}>
                            {trans('VietnamWorks profile')}: {trans('Not Approved')}
                        </Paragraph>
                        <Paragraph name={'body'} size={'medium'} color={colors.grey[20]} style={{ marginTop: 8 }}>
                            {trans(
                                'To enable VietnamWorks Profile, your VietnamWorks Profile needs to be completed and approved.'
                            )}
                        </Paragraph>
                    </>
                )}
                {[EDevice.MOBILE, EDevice.TABLET].includes(state.device) ? (
                    <div style={{ marginTop: 10, display: 'flex', gap: 10, flexWrap: 'wrap' }}>
                        <Button type='info' size='sm' outline='outline' onClick={onUpdateProfileBtnClick}>
                            {trans('Update profile')}
                        </Button>
                        <Button
                            type='info'
                            size='sm'
                            outline='outline'
                            onClick={(e) => {
                                e.stopPropagation()
                                window.open(`${vnwBasePath}/${trans('preview-resume')}/${profile.id}`, '_blank')
                            }}
                        >
                            {trans('View as employer')}
                        </Button>
                    </div>
                ) : (
                    <RightButtonWrapper active={true}>
                        <Button type='info' size='sm' outline='outline' onClick={onUpdateProfileBtnClick}>
                            {trans('Update profile')}
                        </Button>
                        <Button
                            type='info'
                            size='sm'
                            outline='outline'
                            onClick={(e) => {
                                e.stopPropagation()
                                window.open(`${vnwBasePath}/${trans('preview-resume')}/${profile.id}`, '_blank')
                            }}
                        >
                            {trans('View as employer')}
                        </Button>
                    </RightButtonWrapper>
                )}
            </OptionGroup>
        </>
    )
}

export default React.memo(OnlineProfile)
